module.exports = __webpack_public_path__ + "img/Gruppenführer.b1acfa02.svg";